// extracted by mini-css-extract-plugin
export default {"hero":"FeaturedPost_hero__NncWm","copy-container":"FeaturedPost_copy-container__prEYp","copy":"FeaturedPost_copy__kAtPu"};